import css from 'styled-jsx/css';

const styles = css.global`#banco-do-auto-financie-pesado {
    /* height: 514px; */
    display: block;
    background: #C00;
    position: relative;
    overflow: hidden;
    padding-bottom: 50px;
}

#banco-do-auto-financie-pesado .bg-vermelho {
    background: #900;
    height: 257px;
    width: 100%;
    position: absolute;
    top: 0;
}

#banco-do-auto-financie-pesado .container-texto {
    position: relative;
    z-index: 9;
    padding-top: 40px;
}

#banco-do-auto-financie-pesado .container-texto .paragrafo {
    color: #FFF;
    text-align: center;
    font-family: "SantanderText";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 90%;
    max-width: 185px;
    margin: 0 auto;
    text-align: end;
}

#banco-do-auto-financie-pesado .container-texto.segundo .paragrafo {
    text-align: center;
}

#banco-do-auto-financie-pesado .container-texto.segundo {
    padding-top: 30px;
}


#banco-do-auto-financie-pesado .container-texto .negrito {
    color: #FFF;
    font-family: "SantanderHeadline";
    font-size: 80px;
    font-style: normal;
    font-weight: 800;
    line-height: 90%;
    display: block;
    text-align: center;
    margin: 5px auto;
}

#banco-do-auto-financie-pesado .caminhoes {
    z-index: 9;
    position: relative;
    display: block;
    margin-top: 10px;
    width: 100%;
    max-width: 350px;
    margin: 0 auto;
}

#banco-do-auto-financie-pesado .acelerador {
    z-index: 9;
    position: absolute;
    display: block;
    top: 0;
    opacity: 0.5;
    mix-blend-mode: color-burn;
}

#banco-do-auto-financie-pesado .segundo-acelerador {
    z-index: 9;
    position: absolute;
    display: block;
    bottom: 0;
    right: 0;
    mix-blend-mode: color-burn;
    opacity: .6;
}

#banco-do-auto-financie-pesado .container-financie {
    position: relative;
    height: 100%;
}

#banco-do-auto-financie-pesado .container-texto-desktop,
#banco-do-auto-financie-pesado .segundo-acelerador.desktop,
#banco-do-auto-financie-pesado .acelerador.desktop {
    display: none;
}

#banco-do-auto-financie-pesado .financie-btn-white {
    margin: 40px auto 0;
    width: 272px;
    height: 48px;
    z-index: 10;
    position: relative;
}

@media(min-width: 992px) {

    #banco-do-auto-financie-pesado .segundo-acelerador,
    #banco-do-auto-financie-pesado .acelerador {
        display: none;
    }

    #banco-do-auto-financie-pesado .segundo-acelerador.desktop,
    #banco-do-auto-financie-pesado .acelerador.desktop {
        display: block;
    }


    #banco-do-auto-financie-pesado .container-texto {
        position: absolute;
        right: 0;
        padding-top: 50px;
    }

    #banco-do-auto-financie-pesado .container-texto-desktop .container-texto {
        position: relative;
        padding-top: 0px;
        display: flex;
        align-items: center;
        flex-direction: column;
        z-index: 15;
    }

    #banco-do-auto-financie-pesado .container-texto-desktop .container-texto b {
        color: #FFF;
        font-family: "SantanderText";
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
    }

    #banco-do-auto-financie-pesado {
        height: 844px;
        display: flex;
    }

    #banco-do-auto-financie-pesado .caminhoes {
        max-width: unset;
        margin-top: 40px;
        max-height: 550px;
        left: 50px;
    }

    #banco-do-auto-financie-pesado .bg-vermelho {
        height: 100%;
        width: 50%;
    }

    #banco-do-auto-financie-pesado .container-texto .paragrafo {
        text-align: center;
        font-size: 20px;
    }

    #banco-do-auto-financie-pesado .container-texto.segundo {
        padding-top: 0;
        top: 425px;
        left: 0;
        max-width: 145px;
    }

    #banco-do-auto-financie-pesado .container-texto-desktop {
        display: flex;
        flex-direction: column;
        margin-top: 15px;
    }

    #banco-do-auto-financie-pesado .container-texto-desktop .content {
        display: flex;
        justify-content: space-evenly;
    }

    #banco-do-auto-financie-pesado .container-texto .paragrafo {
        max-width: 272px;
    }

    

    #banco-do-auto-financie-pesado .container-texto.terceiro .paragrafo {
        font-size: 24px;
    }
}`;

export default styles;